import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import logo from "@/assets/c4b-logo.png";

function Pill({ count, active }) {
  if (count == null) return null;
  return (
    <span
      className="num"
      style={{
        marginLeft: "auto", fontSize: 11, padding: "2px 8px", borderRadius: 9999,
        color: active ? "var(--ui-on-accent)" : "var(--ui-text-mid)",
        background: active ? "var(--ac-indigo)" : "var(--ui-card-2)",
      }}
    >
      {count.toLocaleString("en-AU")}
    </span>
  );
}

function Item({ to, label, count }) {
  const loc = useLocation();
  const active = to === "/" ? loc.pathname === "/" : loc.pathname.startsWith(to);
  return (
    <NavLink to={to} data-testid={`nav-${label.toLowerCase().replace(/ /g, "-")}`}
      style={{ textDecoration: "none" }}>
      <div
        className="flex items-center"
        style={{
          gap: 12, padding: "12px 14px", borderRadius: 11, marginBottom: 4,
          position: "relative",
          background: active ? "var(--ac-indigo-soft)" : "transparent",
          border: active ? "1px solid var(--ac-indigo)" : "1px solid transparent",
          boxShadow: active ? "var(--glow-indigo)" : "none",
        }}
      >
        <span style={{
          position: "absolute", left: 0, top: 10, bottom: 10, width: 3,
          borderRadius: 4,
          background: active ? "var(--ac-indigo)" : "var(--ui-line)",
          opacity: active ? 1 : 0.6,
        }} />
        <span className="prose-i" style={{
          fontSize: 14, fontWeight: active ? 600 : 500,
          color: active ? "var(--ui-text-hi)" : "var(--ui-text-mid)",
        }}>{label}</span>
        <Pill count={count} active={active} />
      </div>
    </NavLink>
  );
}

export default function Rail({ role, counts, sync }) {
  return (
    <aside
      style={{
        width: 248, minWidth: 248, height: "100vh", position: "sticky", top: 0,
        background: "var(--ui-rail)", borderRight: "1px solid var(--ui-line-soft)",
        display: "flex", flexDirection: "column", padding: "22px 16px",
      }}
    >
      <img src={logo} alt="coffee4business" style={{ width: 186, objectFit: "contain", marginBottom: 34, marginLeft: 6 }} />

      <nav style={{ flex: 1 }}>
        <Item to="/" label="Leak Board" count={counts?.leakBoard} />
        <Item to="/accounts" label="Accounts" count={counts?.accounts} />
        <Item to="/snapshot" label="Snapshot" />
        {(role === "admin" || role === "super_admin") && <Item to="/thresholds" label="Thresholds" />}
        {role === "super_admin" && <Item to="/connection" label="Connection" />}
        {role === "super_admin" && <Item to="/users" label="Users" />}
        <Item to="/health" label="Data Health" count={counts?.dataHealth} />
      </nav>

      <div style={{
        background: "var(--ui-card)", borderRadius: 13, padding: "14px 16px",
        border: "1px solid var(--ui-line-soft)",
      }}>
        <div className="flex items-center" style={{ gap: 8 }}>
          <span style={{ width: 7, height: 7, borderRadius: 9999,
            background: "var(--sv-good)", boxShadow: "var(--glow-good)" }} />
          <span className="prose-i" style={{ fontSize: 13, color: "var(--ui-text-hi)", fontWeight: 500 }}>
            Synced
          </span>
        </div>
        <div className="num" style={{ fontSize: 12, color: "var(--ui-text-lo)", marginTop: 6 }}>
          {(sync?.clock || "03:04")} · {(sync?.invoiceCount || 0).toLocaleString("en-AU")} invoices
        </div>
      </div>
    </aside>
  );
}
